const abTestVariant = () => {
  const abTestSelector = '[data-ab-test]'
  const abTest = document.querySelector(abTestSelector)

  if (abTest) {
    return abTest.getAttribute(abTestSelector.replace(/[[\]']+/g, ''))
  }
  return ''
}

const cultureCheck = () => {
  const url = new URL(window.location.href)
  if (url.hostname.includes('.nl')) {
    return 'nl'
  }
  if (url.hostname.includes('.de')) {
    return 'de'
  }
  if (url.hostname.includes('.co.uk') || url.hostname.includes('.com')) {
    return 'en'
  }
  return 'nl'
}

const removeAirportWord = (airportName: string): string => {
  return airportName.replace("Airport", "").trim();
};

export { abTestVariant, cultureCheck, removeAirportWord }
